import React, { useState } from 'react';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Labor/WorkerAttendanceCalendar.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const WorkerAttendanceCalendar = ({ attendance, justMarkedDate, justMarkedStatus }) => {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [showYearPicker, setShowYearPicker] = useState(false);

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
  const getFirstDayIndex = (year, month) => new Date(year, month, 1).getDay();

  const handlePrev = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear((prev) => prev - 1);
    } else {
      setCurrentMonth((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear((prev) => prev + 1);
    } else {
      setCurrentMonth((prev) => prev + 1);
    }
  };

  const totalDays = getDaysInMonth(currentYear, currentMonth);
  const startDay = getFirstDayIndex(currentYear, currentMonth);

  const getStatusClass = (day) => {
    const month = String(currentMonth + 1).padStart(2, '0');
    const date = String(day).padStart(2, '0');
    const key = `${currentYear}-${month}-${date}`;

    let status = attendance[key]?.toLowerCase();

    // ✅ Local override for just-marked day
    if (justMarkedDate === key && justMarkedStatus) {
      status = justMarkedStatus.toLowerCase();
    }

    if (!status) return 'no-data';
    if (!['present', 'absent', 'leave'].includes(status)) return 'no-data';
    return status;
  };

  return (
    <div className="worker-drawer-calendar-card">
      <div className="worker-drawer-calendar-header">
        <h4>Attendance</h4>
        <div className="worker-drawer-calendar-controls">
          <FaChevronLeft onClick={handlePrev} className="clickable" />
          <span>{monthNames[currentMonth]}</span>
          <FaChevronRight onClick={handleNext} className="clickable" />
        </div>
        <div className="worker-drawer-year-container">
          <span className="worker-drawer-calendar-year" onClick={() => setShowYearPicker(!showYearPicker)}>
            {currentYear}
          </span>

          {showYearPicker && (
            <div className="worker-drawer-year-popup">
              <button
                className="worker-drawer-reset-btn"
                onClick={() => {
                  const today = new Date();
                  setCurrentYear(today.getFullYear());
                  setCurrentMonth(today.getMonth());
                  setShowYearPicker(false);
                }}
              >
                Go to Current Year
              </button>
              <div className="worker-drawer-year-picker">
                {[...Array(10)].map((_, idx) => {
                  const year = new Date().getFullYear() - idx;
                  return (
                    <div
                      key={year}
                      className="worker-drawer-year-option"
                      onClick={() => {
                        setCurrentYear(year);
                        setShowYearPicker(false);
                      }}
                    >
                      {year}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="worker-drawer-weekdays">
        {daysOfWeek.map((day) => (
          <div key={day} className="worker-drawer-weekday">
            {day}
          </div>
        ))}
      </div>

      <div className="worker-drawer-calendar-grid real-grid">
        {[...Array(startDay)].map((_, i) => (
          <div key={`empty-${i}`} className="worker-drawer-day empty"></div>
        ))}
        {Array.from({ length: totalDays }, (_, i) => {
          const day = i + 1;
          return (
            <div key={day} className={`worker-drawer-day ${getStatusClass(day)}`}>
              {day}
            </div>
          );
        })}
      </div>

      <div className="worker-drawer-calendar-legend">
        <div><span className="present-box" /> Present</div>
        <div><span className="absent-box" /> Absent</div>
        <div><span className="leave-box" /> Leave</div>
        <div><span className="no-data-box" /> No Data</div>
      </div>
    </div>
  );
};

export default WorkerAttendanceCalendar;
